export const tableHelpers = {
    data() {
        return {
            tableColumns: [

                {
                    title: "Organismo de Acreditación",
                    type: 'text',
                    key: 'name',
                },
                {
                    title: "Alcance",
                    type: 'text',
                    key: 'scope',
                },
                {
                    title: 'Estado de Acreditación',
                    type: 'text',
                    key: 'status',
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}